import { isEmpty } from 'lodash';
import React from 'react';
import FormattedField from './formatted-field';
import currencyFormatter from 'currency-formatter';

export default (props) => (
    <FormattedField 
        {...props}
        prefix="$"
        format={ 
            (value) => (
                isEmpty(value) ? '' : currencyFormatter.format(value, { code: 'USD' })
            )
        }
        removeFormatting={
            (value) => window.parseInt(value.replace(/[^\d]+/, ''), 10)
        }
    />
);
